<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "FinancialReportActionLayout"
    }
</script>

<style scoped>

</style>
